var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2062,
    height: 681,
    viewBox: "0 0 2062 681",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1821.68 240.593V291.347H1680.74V326.582H1812.87V370.625H1680.74V440.255H1619.92V240.593H1821.68Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1592.7 240.593V291.347H1451.76V326.582H1583.89V370.625H1451.76V440.255H1390.94V240.593H1592.7Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.59 235.14C1312.96 235.14 1362.04 281.28 1362.04 340.843C1362.04 400.407 1312.96 446.547 1231.59 446.547C1149.79 446.547 1100.72 400.407 1100.72 340.843C1100.72 281.28 1149.79 235.14 1231.59 235.14ZM1231.59 397.89C1271.86 397.89 1298.28 373.561 1298.28 340.843C1298.28 308.126 1271.86 284.216 1231.59 284.216C1190.9 284.216 1164.89 308.126 1164.89 340.843C1164.89 373.561 1190.9 397.89 1231.59 397.89Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M952.917 364.753H936.139V440.255H875.317V240.593H936.139V315.676H952.917L1026.32 240.593H1102.66L1005.35 336.229L1106.44 440.255H1025.48L952.917 364.753Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M609.878 240.593H666.085L771.37 350.072V240.593H829.255V440.255H775.564L667.763 329.938V440.255H609.878V240.593Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M563.836 240.593V440.255H500.917V240.593H563.836Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M389.328 440.255H326.409V293.864H240V240.593H475.736V293.864H389.328V440.255Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.b3f01e64f1bb27ff234c7de9b6c9b808.svg";
export { ForwardRef as ReactComponent };